"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HrStyled = void 0;

var _utils = require("../../utils");

var _const = require("../../const");

var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HrStyled = (0, _utils.styled)('hr')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: 0;\n  background: ", ";\n  height: 1px;\n  display: block;\n  ", "\n"])), function (_ref) {
  var $color = _ref.$color;
  return _const.Colors[$color];
}, function (props) {
  return (0, _const.spacingStyle)(props);
});
exports.HrStyled = HrStyled;